import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EStepActionTypes {
  Next = 'NEW_REVIEW/STEP/NEXT',
  Prev = 'NEW_REVIEW/STEP/PREV',
  Reset = 'NEW_REVIEW/STEP/RESET',
}

export type TNextStep = ITypedReduxAction<EStepActionTypes.Next>;
export type TPrevStep = ITypedReduxAction<EStepActionTypes.Prev>;
export type TResetStep = ITypedReduxAction<EStepActionTypes.Reset>;

export type TNewReviewFormStepActions = TNextStep | TPrevStep | TResetStep;

export const setNextStep: () => TNextStep = actionGenerator<EStepActionTypes.Next>(EStepActionTypes.Next);
export const setPrevStep: () => TPrevStep = actionGenerator<EStepActionTypes.Prev>(EStepActionTypes.Prev);
export const resetStep: () => TResetStep = actionGenerator<EStepActionTypes.Reset>(EStepActionTypes.Reset);
